(function ($) {
    "use strict";

    var CartPageEventsGa4 = function () {
        /**
         *
         * @param element
         * @param position
         * @param listName
         * @param event
         */
        this.dataLayerObject = function (element, position, listName, event) {
            var object = {
                event: event,
                ecommerce: {
                    items: [],
                },
            };

            return object;
        };

        /**
         *
         * @param price
         */
        this.sanitizePrice = function (price) {
            return Number(price.replace("R$ ", "").replace(",", "."));
        };

        /**
         *
         * @param element
         * @param position
         * @returns {[{quantity: string, list: string, dimension54: (string|string), dimension53: (string|string), dimension55: string, price: number, dimension52: (string|string), dimension51: (string|string), name: string, variant: *, id: *, position, category: (string|string), brand: string}]}
         */
        this.formatProducts = function (element, position) {
            const brand = element
                .find("h3")
                .text()
                .toLowerCase()
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "");
            const name = element
                .find("p")
                .text()
                .toLowerCase()
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "");
            const price = element.find("span").eq(1).text();
            const originalPrice = element.find("span").eq(0).text();
            const discount =
                this.sanitizePrice(originalPrice) - this.sanitizePrice(price);
            const sku = element.data("sku").toLowerCase();
            const categories = element.data("categories").split(",");
            const variant = element
                .data("variant")
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "");
            const seller = element
                .data("seller")
                .trim()
                .toLowerCase()
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "");

            return {
                item_id: sku,
                item_name: name,
                item_brand: brand,
                item_category:
                    categories[0] !== undefined
                        ? categories[0]
                              .trim()
                              .toLowerCase()
                              .normalize("NFD")
                              .replace(/[\u0300-\u036f]/g, "")
                        : "",
                item_category2:
                    categories[1] !== undefined
                        ? categories[1]
                              .trim()
                              .toLowerCase()
                              .normalize("NFD")
                              .replace(/[\u0300-\u036f]/g, "")
                        : "",
                item_category3:
                    categories[2] !== undefined
                        ? categories[2]
                              .trim()
                              .toLowerCase()
                              .normalize("NFD")
                              .replace(/[\u0300-\u036f]/g, "")
                        : "",
                price: Number(price.replace("R$ ", "").replace(",", ".")),
                discount: parseInt(discount * 100) / 100,
                index: position,
                affiliation: "dafiti br - " + seller,
                item_list_name: "cart page - recomendados para voce",
                item_variant: variant,
            };
        };

        /**
         *
         * @param element
         * @returns {{position: *, closest: (*|jQuery|Element|SVGSymbolElement|SVGMetadataElement|SVGUseElement|SVGAnimateElement|SVGFEImageElement|SVGPathElement|SVGViewElement|SVGFEConvolveMatrixElement|SVGFECompositeElement|SVGEllipseElement|SVGFEOffsetElement|SVGTextElement|SVGDefsElement|SVGFETurbulenceElement|SVGImageElement|SVGFEFuncGElement|SVGMPathElement|SVGTSpanElement|SVGClipPathElement|SVGLinearGradientElement|SVGFEFuncRElement|SVGScriptElement|SVGFEColorMatrixElement|SVGFEComponentTransferElement|SVGStopElement|SVGMarkerElement|SVGFEMorphologyElement|SVGFEMergeElement|SVGFEPointLightElement|SVGForeignObjectElement|SVGFEDiffuseLightingElement|SVGStyleElement|SVGFEBlendElement|SVGCircleElement|SVGPolylineElement|SVGDescElement|SVGFESpecularLightingElement|SVGLineElement|SVGFESpotLightElement|SVGFETileElement|SVGPatternElement|SVGTitleElement|SVGSwitchElement|SVGRectElement|SVGFEDisplacementMapElement|SVGFEFuncAElement|SVGFEFuncBElement|SVGFEMergeNodeElement|SVGTextPathElement|SVGFEFloodElement|SVGMaskElement|SVGAElement|SVGAnimateTransformElement|SVGSetElement|SVGSVGElement|SVGAnimateMotionElement|SVGGElement|SVGFEDistantLightElement|SVGFEDropShadowElement|SVGRadialGradientElement|SVGFilterElement|SVGPolygonElement|SVGFEGaussianBlurElement|HTMLSelectElement|HTMLLegendElement|HTMLElement|HTMLTableCaptionElement|HTMLTextAreaElement|HTMLModElement|HTMLHRElement|HTMLOutputElement|HTMLEmbedElement|HTMLCanvasElement|HTMLScriptElement|HTMLInputElement|HTMLMetaElement|HTMLStyleElement|HTMLObjectElement|HTMLTemplateElement|HTMLBRElement|HTMLAudioElement|HTMLIFrameElement|HTMLMapElement|HTMLTableElement|HTMLAnchorElement|HTMLMenuElement|HTMLPictureElement|HTMLParagraphElement|HTMLTableCellElement|HTMLTableSectionElement|HTMLQuoteElement|HTMLProgressElement|HTMLLIElement|HTMLTableRowElement|HTMLSpanElement|HTMLTableColElement|HTMLOptGroupElement|HTMLDataElement|HTMLDListElement|HTMLFieldSetElement|HTMLSourceElement|HTMLBodyElement|HTMLDivElement|HTMLUListElement|HTMLDetailsElement|HTMLHtmlElement|HTMLAreaElement|HTMLPreElement|HTMLMeterElement|HTMLOptionElement|HTMLImageElement|HTMLLinkElement|HTMLHeadingElement|HTMLSlotElement|HTMLVideoElement|HTMLTitleElement|HTMLButtonElement|HTMLHeadElement|HTMLDialogElement|HTMLTrackElement|HTMLOListElement|HTMLDataListElement|HTMLLabelElement|HTMLFormElement|HTMLTimeElement|HTMLBaseElement)}}
         */
        this.getClosestAndPosition = function (element) {
            var closest = $(element).closest(".product-guide-item");
            var position = closest.prevAll().length;

            return { closest: closest, position: position };
        };

        /**
         *
         * @param element
         * @returns bool
         */
        this.isElementInViewportGa4 = function (element) {
            var container =
                $(element).closest(".product-guide-overflow").length > 0
                    ? $(element).closest(".product-guide-overflow")
                    : $(element).closest(".product-guide-overflow");

            if (!$(element).is(":visible")) {
                return false;
            }

            return (
                $(element)[0].getBoundingClientRect().left >=
                    $(container)[0].getBoundingClientRect().left - 10 &&
                $(element)[0].getBoundingClientRect().right <=
                    $(container)[0].getBoundingClientRect().right + 10 &&
                $(element)[0].getBoundingClientRect().top >= 0 &&
                $(element)[0].getBoundingClientRect().bottom <=
                    (window.innerHeight || $(window).height())
            );
        };

        this.getObjectBtnCart = function (element) {
            var closest = element.closest;
            var position = element.position;

            return { closest: closest, position: position };
        };

        return this;
    };

    var _dataLayerFiltered = dataLayer.filter(function (e) {
        return e.ET;
    })[0];

    // Verifica se está sendo executado na loja dafiti e se está na página de cart.
    if (
        _dataLayerFiltered != undefined &&
        document.location.hostname.indexOf("dafiti") > -1 &&
        _dataLayerFiltered.ET === "cartpage"
    ) {
        //Taggueamento GA4 - Select Item
        $(document).on("click", ".product-box-image", function () {
            var cartEvents = new CartPageEventsGa4();
            var getClosestAndPosition = cartEvents.getClosestAndPosition(this);

            var object = cartEvents.dataLayerObject(
                getClosestAndPosition.closest,
                getClosestAndPosition.position + 1,
                getClosestAndPosition.closest.data("type"),
                "select_item_ga4"
            );

            var formattedProduct = cartEvents.formatProducts(
                getClosestAndPosition.closest,
                getClosestAndPosition.position + 1,
                getClosestAndPosition.closest.data("type")
            );

            object.ecommerce.items.push(formattedProduct);
            dataLayer.push(object);
            if (window.DD_RUM && window.DD_RUM.addAction) {
                window.DD_RUM.addAction(object.event, object);
            }
        });

        //Taggueamento GA4 - View Item List
        $(document).on("DOMSubtreeModified", function (e) {
            var cartEvents = new CartPageEventsGa4();
            var object = {};

            $(".carousel-item").each(function (i) {
                if (
                    cartEvents.isElementInViewportGa4($(this)) &&
                    !$(this).hasClass("impressionGA4")
                ) {
                    $(this).addClass("impressionGA4");
                    var getClosestAndPosition =
                        cartEvents.getClosestAndPosition(this);

                    if (Object.keys(object).length === 0) {
                        object = cartEvents.dataLayerObject(
                            getClosestAndPosition.closest,
                            getClosestAndPosition.position + 1,
                            getClosestAndPosition.closest.data("type"),
                            "view_item_list_ga4"
                        );
                    }

                    var formattedProduct = cartEvents.formatProducts(
                        getClosestAndPosition.closest,
                        getClosestAndPosition.position + 1,
                        getClosestAndPosition.closest.data("type")
                    );

                    object.ecommerce.items.push(formattedProduct);
                }
            });

            if (Object.keys(object).length !== 0) {
                dataLayer.push(object);
                if (window.DD_RUM && window.DD_RUM.addAction) {
                    window.DD_RUM.addAction(object.event, object);
                }
            }
        });

        $(document).on("click", ".recommendations-next", function (e) {
            setTimeout(function () {
                var cartEvents = new CartPageEventsGa4();
                $(".carousel-item").each(function (i) {
                    if (
                        cartEvents.isElementInViewportGa4($(this)) &&
                        !$(this).hasClass("impressionGA4")
                    ) {
                        $(this).addClass("impressionGA4");
                        var getClosestAndPosition =
                            cartEvents.getClosestAndPosition(this);

                        var object = cartEvents.dataLayerObject(
                            getClosestAndPosition.closest,
                            getClosestAndPosition.position + 1,
                            getClosestAndPosition.closest.data("type"),
                            "view_item_list_ga4"
                        );
                        var formattedProduct = cartEvents.formatProducts(
                            getClosestAndPosition.closest,
                            getClosestAndPosition.position + 1,
                            getClosestAndPosition.closest.data("type")
                        );

                        object.ecommerce.items.push(formattedProduct);

                        dataLayer.push(object);
                        if (window.DD_RUM && window.DD_RUM.addAction) {
                            window.DD_RUM.addAction(object.event, object);
                        }
                    }
                });
            }, 500);
        });
    }
})(jQuery);
